// @flow

import type {Language, PortfolioNotificationEvent} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {map} from 'ramda'
import {date} from '@/format'
import {portfoliosActions} from '@/store'
import {hideScoreForCountries} from '@/defaults'
import {getRuleName, getReportLinkDetailsForGA, checkRuleText} from '@/views/util'

import Flag from '@/elements/flag'

import './index.css'

type Props = {
  notifications: Array<PortfolioNotificationEvent>,
  l: Language,
  showCompanyReport: (companyId: string) => void,
  langCode: string,
  countryCode: string,
}

// this method is used for splitting the band and the text followed by
// We need to translate the text after the band
const splitValuesForTranslation = (val) => {
  const regEx = /^(E)\s(\w+\s*.*)/
  const regExResult = regEx.exec(val)
  // now the regExResult contains an array as below
  // [matched string, paranthesis matched strings]
  if (regExResult) {
    return [regExResult[1], regExResult[2]]
  }
  return val
}

const getDisplayedStringForValue = (val, l) => {
  const splittedValue = splitValuesForTranslation(val)
  if (Array.isArray(splittedValue)) {
    return splittedValue.map((val) => l(val)).join(' ')
  }
  return l(val)
}

const getEventChangeValues = ({oldValue, newValue}, l) => {
  if (oldValue && newValue) {
    return `${l('Old:')} ${getDisplayedStringForValue(oldValue, l)} - ${l('New:')} ${getDisplayedStringForValue(newValue, l)}`
  }
  return oldValue ? `${l('Old:')} ${getDisplayedStringForValue(oldValue, l)}`
    : newValue ? `${l('New:')} ${getDisplayedStringForValue(newValue, l)}`
      : ''
}

const getFormattedCompanyName = (companyName: ?string) => {
  if (companyName && companyName.length > 35) {
    return <span title={companyName}>{`${companyName.substr(0, 35)}... - `}</span>
  }
  return companyName ? companyName + ' - ' : companyName
}

const isScoreHidden = (companyCountryCode: string) => {
  return hideScoreForCountries.indexOf(companyCountryCode) > -1
}

export const RawEventsList = (props: Props) => {
  const renderCol = (langCode: string) => (notification: PortfolioNotificationEvent) =>
    <div key={notification.notificationEventId} className="col-xs-6 notification">
      <div className="row">
        <div className="col-xs-1">
          <Flag code={notification.companyCountryCode} />
          {notification.companyCountryCode}
        </div>
        <div className="col-xs-11">
          <div>{getFormattedCompanyName(notification.companyName)}{date(notification.eventDate, langCode)}</div>
          <div className="truncate">{getRuleName(checkRuleText(notification), props.l)}</div>
          <div className="truncate">{!isScoreHidden(notification.companyCountryCode) ? getEventChangeValues(notification, props.l) : false}</div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-11 col-xs-push-1 web-report-link">
          <a data-click_through={getReportLinkDetailsForGA(props.countryCode, notification.companyId)}
            onClick={() => {
              props.showCompanyReport(notification.companyId)
            }}
          >
            {props.l('view full report')}
          </a>
        </div>
      </div>
    </div>

  const renderCols = (langCode) => map(renderCol(langCode))

  return (
    <div className="events">
      {props.notifications.length > 0 ? renderCols(props.langCode)(props.notifications) : props.l('No recent events')}
    </div>
  )
}

export default connect(
  null,
  portfoliosActions,
)(RawEventsList)



// WEBPACK FOOTER //
// ./src/views/home-page/events-list.js